import React from 'react';
import Box from '@mui/material/Box';

const animalLabels = {
  '🐱': 'kedi',
  '🐶': 'köpek',
  '🐰': 'tavşan',
  '🦊': 'tilki',
};

const animalCharacters = new Set(Object.keys(animalLabels));

export function hasAnimalSymbol(text) {
  return Array.from(String(text || '')).some((character) => animalCharacters.has(character));
}

export function isSingleAnimalSymbol(text) {
  return animalCharacters.has(String(text || '').trim());
}

export function animalAccessibleLabel(text) {
  return Array.from(String(text || ''))
    .map((character) => (animalLabels[character] ? `${animalLabels[character]} ` : character))
    .join('')
    .replace(/\s+/g, ' ')
    .trim();
}

export default function PatternAnimalSymbols({ text, decorative = false }) {
  const parts = String(text || '').split(/([🐱🐶🐰🦊])/u).filter(Boolean);
  return (
    <Box
      component="span"
      role={decorative ? undefined : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : animalAccessibleLabel(text)}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.12em',
        fontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
        fontWeight: 400,
        lineHeight: 1,
      }}
    >
      {parts.map((part, index) => {
        if (animalCharacters.has(part)) {
          return (
            <Box key={`${part}-${index}`} component="span" aria-hidden="true" sx={{ lineHeight: 1 }}>
              {part}
            </Box>
          );
        }
        if (!part.trim()) return <Box key={`space-${index}`} component="span" sx={{ width: '0.12em' }} />;
        return <Box key={`${part}-${index}`} component="span" sx={{ fontFamily: 'inherit', fontSize: '0.56em', fontWeight: 1000, whiteSpace: 'pre-wrap' }}>{part.trim()}</Box>;
      })}
    </Box>
  );
}
